import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlToggleProps } from './toggle.props';
import {
   ToggleSize,
   ToggleSizeValuesMap,
   ToggleVariant,
   ToggleVariantValuesMap,
} from './toggle.types';
import { getGlobalStyleSheets } from '../../global-styles';
import { enumAttributeConverter } from '../enum-types';

import * as ToggleTags from './toggle.tagnames';
import { ToggleChangeEvent } from './toggle.events';

@customElement(ToggleTags.Toggle)
export class AtlToggle extends LitElement implements AtlToggleProps {
   declare checked: boolean;
   declare targetId: string;
   declare variant?: ToggleVariant;
   declare size?: ToggleSize;
   declare disabled?: boolean;

   static properties = {
      checked: { type: Boolean, state: true },
      targetId: { type: String },
      variant: {
         type: String,
         converter: enumAttributeConverter(
            ToggleVariant,
            ToggleVariant.Primary
         ),
      },
      size: {
         type: String,
         converter: enumAttributeConverter(ToggleSize, ToggleSize.Medium),
      },
      disabled: { type: Boolean },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         .atl-slider-disabled {
            opacity: 0.5;
            cursor: context-menu !important;
         }
      `,
   ];

   render() {
      const switchClass = [
         'atl-switch',
         ToggleSizeValuesMap[this.size ?? ToggleSize.Medium],
         '',
      ];
      const sliderClass = [
         'atl-slider',
         ToggleSizeValuesMap[this.size ?? ToggleSize.Medium],
         ToggleVariantValuesMap[this.variant ?? ToggleVariant.Primary],
      ];
      if (this.disabled) {
         sliderClass.push('atl-slider-disabled');
      }

      return html`
         <div>
            <slot></slot>
            <label id=${this.targetId} class=${switchClass.join(' ')}>
               <input
                  type="checkbox"
                  name="{name}"
                  @change=${this._handleOnChange}
                  ?checked=${this.checked === true}
                  ?disabled=${this.disabled === true}
               />
               <span class=${sliderClass.join(' ')}></span>
            </label>
         </div>
      `;
   }

   private _handleOnChange = () =>
      this.dispatchEvent(new ToggleChangeEvent(!this.checked));
}
